import { minusOnePx, useMedia, useTheme } from "@catchoftheday/theme";
export const useIsMobile = (desktopBreakpoint = "md") => {
    const theme = useTheme();
    const isMobile = useMedia([`(max-width: ${minusOnePx(theme.breakpoints[desktopBreakpoint], true)})`], [true]);
    return isMobile;
};
